import { render } from "./Shiiresakilist.vue?vue&type=template&id=2e902408&ts=true"
import script from "./Shiiresakilist.vue?vue&type=script&lang=ts"
export * from "./Shiiresakilist.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__